import React, { useEffect, useState } from 'react';
import axios from '../../api/axios';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const NewCustomer = () => {
    const { customerId } = useParams()
    const navigate = useNavigate()
    const [state, setState] = useState({ name: '', phone: '', email: '', address: '' })
    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};
        if (!state.name) newErrors.name = "name is required";
        if (!state.phone) newErrors.phone = "phone is required";
        if (!state.address) newErrors.address = "address is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    useEffect(() => {
        if (customerId) {
            axios.get(`/customers/${customerId}`).then((res) => {
                setState({ ...state, name: res.data?.name, phone: res.data.phone, email: res.data.email, address: res.data.address })
                console.log(res.data);
            });
        }
    }, [customerId])
    const handleSubmit = (e) => {
        e.preventDefault()
        if (!validateForm()) return;

        const payload = {
            name: state.name,
            email: state.email,
            phone: state.phone,
            address: state.address
        }
        const apiUrl = customerId
            ? `/customers/${customerId}`  // Update endpoint
            : '/customers';           // Create endpoint

        const apiCall = customerId
            ? axios.put(apiUrl, payload)                   // Use PUT for update
            : axios.post(apiUrl, payload);                 // Use POST for create

        apiCall
            .then(res => {
                if (res.data.success === true) {
                    toast.success(res.data?.message || `Category ${customerId ? 'updated' : 'created'} successfully!`)
                    navigate('/customers-list')
                } else {
                    toast.error(res.data?.message || `Category ${customerId ? 'updated' : 'created'} successfully!`)
                }
            })
            .catch(err => toast.error(err.message || `Error`));
    }
    return (
        <div className="p-4 max-w-6xl mx-auto text-sm bg-white rounded-md">
            <h2 className="text-xl font-bold mb-4">Customer — Add/Update</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid md:grid-cols-3 gap-4 mb-4">
                    <div>
                        <label className="font-semibold text-sm">Customer Name *</label>
                        <input
                            type="text"
                            value={state?.name}
                            placeholder='Enter name'
                            onChange={(e) => {
                                setState({ ...state, name: e.target.value })
                                if (errors.name) setErrors(prev => ({ ...prev, name: null }))
                            }}
                            className={errors.name ? 'border-red-500 border w-full rounded mt-1' : 'border w-full rounded mt-1'}
                        />
                        {errors.name && <p className="text-red-500 text-xs">{errors.name}</p>}
                    </div>
                    <div>
                        <label className="font-semibold text-sm">Mobile Number *</label>
                        <input
                            type="text"
                            value={state?.phone}
                            placeholder='Enter mobile'
                            onChange={(e) => {
                                setState({ ...state, phone: e.target.value })
                                if (errors.phone) setErrors(prev => ({ ...prev, phone: null }))
                            }}
                            className={errors.phone ? 'border-red-500 border w-full rounded mt-1' : 'border w-full rounded mt-1'}
                        />
                        {errors.phone && <p className="text-red-500 text-xs">{errors.phone}</p>}
                    </div>
                    <div>
                        <label className="font-semibold text-sm">Email Address</label>
                        <input
                            type="email"
                            value={state?.email}
                            placeholder='Enter email'
                            onChange={(e) => setState({ ...state, email: e.target.value })}
                            className="border w-full rounded mt-1"
                        />
                    </div>
                </div>
                <div className="grid md:grid-cols-1 gap-4 mb-4">
                    <div>
                        <label className="font-semibold text-sm">Address *</label>
                        <textarea
                            type="text"
                            value={state?.address}
                            placeholder='Enter address'
                            rows={3}
                            onChange={(e) => {
                                setState({ ...state, address: e.target.value })
                                if (errors.address) setErrors(prev => ({ ...prev, address: null }))
                            }}
                            className={errors.address ? 'border-red-500 border w-full rounded mt-1 p-2' : 'border w-full rounded mt-1 p-2'}
                        />
                        {errors.address && <p className="text-red-500 text-xs">{errors.address}</p>}
                    </div>
                </div>
                <div className="flex justify-center items-center gap-4 mt-4">
                    <button type='submit' className=" bg-green-600 hover:bg-green-700 text-white px-8 py-2 rounded">Save</button>
                    <button type="button" onClick={() => navigate('/customers-list')} className="bg-gray-400 hover:bg-gray-500 text-white px-8 py-2 rounded">Close</button>
                </div>
            </form>
        </div>
    );
};

export default NewCustomer;